webpackJsonp([21],{

/***/ 532:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

__webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var markdownConverter = new _showdown2.default.Converter();

var normalizeAssetUrl = function normalizeAssetUrl(value) {
  return typeof value === 'string' && value.trim().startsWith('//') ? 'https:' + value.trim() : typeof value === 'string' ? value.trim() : '';
};

var isNonEmptyString = function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim().length > 0;
};

var getBlockName = function getBlockName(block) {
  return (block && block.component || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
};

var getAssetUrl = function getAssetUrl(value) {
  if (!value) return '';

  if (typeof value === 'string') return normalizeAssetUrl(value);

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    return normalizeAssetUrl(value.filename || value.url || value.cached_url || value.src || '');
  }

  return '';
};

var getImageSrc = function getImageSrc(block) {
  return getAssetUrl(block && (block.image || block.file || block.logo || block.photo || block.avatar));
};

var getLinkFromValue = function getLinkFromValue(value) {
  if (!value) return '';

  if (typeof value === 'string') {
    if (/^https?:\/\//i.test(value) || value.startsWith('/')) return value;
    return '/' + value;
  }

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    return value.cached_url || value.url || value.link || value.href || value.story && value.story.url || '';
  }

  return '';
};

var toEmbedUrl = function toEmbedUrl(source) {
  if (!isNonEmptyString(source)) return '';

  var trimmed = source.trim();

  if (trimmed.includes('youtube.com/watch?v=')) {
    var base = trimmed.replace('watch?v=', 'embed/');
    return base.split('&')[0];
  }

  return trimmed;
};

var escapeHtml = function escapeHtml(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};

var sanitizeHref = function sanitizeHref(value) {
  if (!isNonEmptyString(value)) return '';

  var href = normalizeAssetUrl(value);

  if (/^javascript:/i.test(href)) return '';

  return href;
};

var storyblokRichTextToHtml = function storyblokRichTextToHtml(value) {
  if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return '';

  var applyMarks = function applyMarks(content, marks) {
    if (!Array.isArray(marks) || !marks.length) return content;

    return marks.reduce(function (acc, mark) {
      if (!mark || (typeof mark === 'undefined' ? 'undefined' : _typeof(mark)) !== 'object') return acc;

      var type = mark.type || '';
      var attrs = mark.attrs || {};

      if (type === 'link') {
        var href = sanitizeHref(attrs.href || attrs.url || attrs.cached_url || '');
        if (!href) return acc;
        var external = /^https?:\/\//i.test(href);
        return '<a href="' + escapeHtml(href) + '"' + (external ? ' target="_blank" rel="noopener noreferrer"' : '') + '>' + acc + '</a>';
      }

      if (type === 'bold') return '<strong>' + acc + '</strong>';
      if (type === 'italic') return '<em>' + acc + '</em>';
      if (type === 'underline') return '<u>' + acc + '</u>';
      if (type === 'strike') return '<s>' + acc + '</s>';
      if (type === 'code') return '<code>' + acc + '</code>';

      return acc;
    }, content);
  };

  var renderNode = function renderNode(node) {
    if (!node) return '';

    if (Array.isArray(node)) return node.map(function (item) {
      return renderNode(item);
    }).join('');

    if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') return '';

    if (node.type === 'text') {
      return applyMarks(escapeHtml(node.text || ''), node.marks);
    }

    if (node.type === 'hard_break') return '<br />';

    var children = renderNode(node.content || []);

    if (node.type === 'doc') return children;
    if (node.type === 'paragraph') return '<p>' + children + '</p>';
    if (node.type === 'bullet_list') return '<ul>' + children + '</ul>';
    if (node.type === 'ordered_list') return '<ol>' + children + '</ol>';
    if (node.type === 'list_item') return '<li>' + children + '</li>';
    if (node.type === 'blockquote') return '<blockquote>' + children + '</blockquote>';
    if (node.type === 'heading') {
      var level = Number(node.attrs && node.attrs.level);
      var safeLevel = level >= 1 && level <= 6 ? level : 3;
      return '<h' + safeLevel + '>' + children + '</h' + safeLevel + '>';
    }

    return children;
  };

  return renderNode(value).trim();
};

var extractStoryblokRichText = function extractStoryblokRichText(value) {
  if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return '';

  var walk = function walk(node) {
    if (!node) return '';

    if (Array.isArray(node)) {
      return node.map(function (item) {
        return walk(item);
      }).join('');
    }

    if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') return '';

    if (node.type === 'text') return node.text || '';
    if (node.type === 'hard_break') return '\n';

    var children = walk(node.content || []);

    if (node.type === 'paragraph' || node.type === 'heading' || node.type === 'list_item' || node.type === 'blockquote') {
      return children + '\n\n';
    }

    return children;
  };

  return walk(value).replace(/\n{3,}/g, '\n\n').trim();
};

var toParagraphs = function toParagraphs(value) {
  return isNonEmptyString(value) ? value.split(/\n{2,}/).map(function (part) {
    return part.trim();
  }).filter(Boolean) : [];
};

var renderRichText = function renderRichText(block) {
  var markdown = isNonEmptyString(block.markdown) ? block.markdown : '';
  var richTextCandidates = [block.richtext, block.rich_text, block.richText, block.text, block.description];

  var richTextObject = richTextCandidates.find(function (value) {
    return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && (value.type === 'doc' || value.content);
  }) || null;

  var richTextHtml = storyblokRichTextToHtml(richTextObject);

  var richTextPlain = richTextCandidates.map(function (value) {
    if (typeof value === 'string') return value.trim();
    return extractStoryblokRichText(value);
  }).find(isNonEmptyString) || '';

  var text = isNonEmptyString(block.text) ? block.text : isNonEmptyString(block.description) ? block.description : richTextPlain;

  var paragraphs = toParagraphs(text);

  if (!richTextHtml && !markdown && !text) return null;

  return _react2.default.createElement(
    'div',
    { className: 'kiana-rich-text' },
    richTextHtml ? _react2.default.createElement('div', { className: 'rich-text', dangerouslySetInnerHTML: { __html: richTextHtml } }) : null,
    !richTextHtml && paragraphs.length ? paragraphs.map(function (paragraph, index) {
      return _react2.default.createElement(
        'p',
        { key: 'p-' + index },
        paragraph
      );
    }) : null,
    !richTextHtml && markdown ? _react2.default.createElement('div', {
      className: 'rich-text',
      dangerouslySetInnerHTML: { __html: markdownConverter.makeHtml(markdown) }
    }) : null
  );
};

var renderVideo = function renderVideo(block, key) {
  var source = toEmbedUrl(block.source || block.url);

  if (!source) return null;

  if (source.includes('<iframe')) {
    return _react2.default.createElement('div', {
      key: key,
      className: 'kiana-video-wrap',
      dangerouslySetInnerHTML: { __html: source }
    });
  }

  return _react2.default.createElement(
    'div',
    { key: key, className: 'kiana-video-wrap' },
    _react2.default.createElement('iframe', {
      title: key,
      className: 'kiana-video',
      src: source,
      frameBorder: '0',
      allow: 'autoplay; encrypted-media; picture-in-picture',
      allowFullScreen: true
    })
  );
};

var renderImage = function renderImage(block, key) {
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'kiana-image';

  var imageSrc = getImageSrc(block);

  if (!imageSrc) return null;

  return _react2.default.createElement(
    'div',
    { key: key, className: 'kiana-image-wrap' },
    _react2.default.createElement('img', { src: imageSrc, alt: block.title || block.name || '', className: className })
  );
};

var renderButtons = function renderButtons(block, key) {
  var items = [];

  if (Array.isArray(block.button)) items.push.apply(items, _toConsumableArray(block.button));
  if (block.label || block.link || block.url) items.push(block);

  var validItems = items.map(function (item, index) {
    var href = getLinkFromValue(item.link || item.url);

    if (!href) return null;

    return {
      item: item,
      index: index,
      href: href,
      label: item.label || item.text || item.title || 'Learn more'
    };
  }).filter(Boolean);

  if (!validItems.length) return null;

  return _react2.default.createElement(
    'div',
    { key: key, className: 'kiana-button-row' },
    validItems.map(function (_ref) {
      var item = _ref.item,
          index = _ref.index,
          href = _ref.href,
          label = _ref.label;

      return _react2.default.createElement(
        'a',
        {
          key: key + '-' + (item._uid || index),
          href: href,
          className: 'button button--green',
          target: href.startsWith('http') ? '_blank' : undefined,
          rel: href.startsWith('http') ? 'noopener noreferrer' : undefined
        },
        label
      );
    })
  );
};

var renderSpantext = function renderSpantext(block, key) {
  if (!block.spantext || !isNonEmptyString(block.spantext)) return null;

  var href = block.spantextlink ? getLinkFromValue(block.spantextlink) : '';

  if (href) {
    return _react2.default.createElement(
      'div',
      { key: key, className: 'kiana-spantext' },
      _react2.default.createElement(
        'a',
        {
          href: href,
          className: 'kiana-spantext-button',
          target: href.startsWith('http') ? '_blank' : undefined,
          rel: href.startsWith('http') ? 'noopener noreferrer' : undefined
        },
        block.spantext
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { key: key, className: 'kiana-spantext' },
    _react2.default.createElement(
      'div',
      { className: 'kiana-spantext-text' },
      block.spantext
    )
  );
};

var renderMember = function renderMember(block, key) {
  return _react2.default.createElement(
    _storyblokReact2.default,
    { key: key, content: block },
    _react2.default.createElement(
      'article',
      { className: 'kiana-member-card' },
      renderImage(block, key + '-image', 'kiana-member-image'),
      _react2.default.createElement(
        'h3',
        { className: 'kiana-member-name' },
        block.name || block.title || ''
      ),
      _react2.default.createElement(
        'div',
        { className: 'kiana-member-description' },
        renderRichText(block)
      ),
      renderButtons(block, key + '-buttons')
    )
  );
};

var isMemberLikeBlock = function isMemberLikeBlock(block) {
  var name = getBlockName(block);

  return name === 'member' || name === 'staff member' || name.includes('member');
};

var looksLikeMemberCard = function looksLikeMemberCard(block) {
  if (!block || (typeof block === 'undefined' ? 'undefined' : _typeof(block)) !== 'object') return false;

  var hasIdentity = isNonEmptyString(block.name) || isNonEmptyString(block.title) || isNonEmptyString(block.full_name);

  var hasImage = !!getImageSrc(block);
  var hasContent = isNonEmptyString(block.description) || isNonEmptyString(block.text) || isNonEmptyString(block.markdown);

  return hasIdentity && (hasImage || hasContent);
};

var collectMemberLikeNodes = function collectMemberLikeNodes(value, rootUid) {
  var bag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (!value) return bag;

  if (Array.isArray(value)) {
    value.forEach(function (item) {
      return collectMemberLikeNodes(item, rootUid, bag);
    });
    return bag;
  }

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return bag;

  var sameAsRoot = !!(rootUid && value._uid && value._uid === rootUid);

  if (!sameAsRoot && (isMemberLikeBlock(value) || looksLikeMemberCard(value))) {
    bag.push(value);
  }

  Object.keys(value).forEach(function (key) {
    collectMemberLikeNodes(value[key], rootUid, bag);
  });

  return bag;
};

var getMemberBlocksFromHub = function getMemberBlocksFromHub(block) {
  if (!block || (typeof block === 'undefined' ? 'undefined' : _typeof(block)) !== 'object') return [];

  var directCandidates = [];

  if (Array.isArray(block.members)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.members));
  if (Array.isArray(block.member)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.member));
  if (Array.isArray(block.people)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.people));
  if (Array.isArray(block.items)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.items));
  if (Array.isArray(block.staff)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.staff));
  if (Array.isArray(block.team)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.team));
  if (Array.isArray(block.filmmakers)) directCandidates.push.apply(directCandidates, _toConsumableArray(block.filmmakers));

  var nestedCandidates = collectMemberLikeNodes(block, block._uid);

  return uniqueBlocks([].concat(directCandidates, _toConsumableArray(nestedCandidates))).filter(function (item) {
    return isMemberLikeBlock(item) || looksLikeMemberCard(item);
  });
};

var renderMembersHub = function renderMembersHub(block, key) {
  var members = getMemberBlocksFromHub(block);

  var sectionTitle = isNonEmptyString(block.title) && block.title.trim() || isNonEmptyString(block.subtitle) && block.subtitle.trim() || isNonEmptyString(block.name) && block.name.trim() || 'Filmmakers';

  return _react2.default.createElement(
    _storyblokReact2.default,
    { key: key, content: block },
    _react2.default.createElement(
      'section',
      { className: 'kiana-section-group' },
      _react2.default.createElement(
        'h2',
        { className: 'kiana-section-title' },
        sectionTitle
      ),
      members.length ? _react2.default.createElement(
        'div',
        { className: 'kiana-members-grid' },
        members.map(function (member, index) {
          return renderMember(member, 'hub-member-' + (member._uid || index));
        })
      ) : _react2.default.createElement(
        'section',
        { className: 'kiana-section' },
        renderRichText(block),
        renderImage(block, key + '-image'),
        renderButtons(block, key + '-buttons')
      )
    )
  );
};

var renderParagraphWithImageCopy = function renderParagraphWithImageCopy(block, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$imageLeft = options.imageLeft,
      imageLeft = _options$imageLeft === undefined ? false : _options$imageLeft,
      _options$magazine = options.magazine,
      magazine = _options$magazine === undefined ? false : _options$magazine,
      _options$largeImage = options.largeImage,
      largeImage = _options$largeImage === undefined ? false : _options$largeImage;

  var imageSrc = getImageSrc(block);

  if (magazine) {
    return _react2.default.createElement(
      _storyblokReact2.default,
      { key: key, content: block },
      _react2.default.createElement(
        'section',
        { className: 'kiana-section kiana-magazine-block' },
        block.title ? _react2.default.createElement(
          'h3',
          { className: 'kiana-fallback-title' },
          block.title
        ) : null,
        imageSrc ? _react2.default.createElement('img', {
          src: imageSrc,
          alt: block.title || block.name || '',
          className: 'kiana-magazine-image ' + (imageLeft ? 'kiana-magazine-image--left' : 'kiana-magazine-image--right') + (largeImage ? ' kiana-magazine-image--large' : '')
        }) : null,
        renderRichText(block),
        renderButtons(block, key + '-buttons'),
        renderSpantext(block, key + '-spantext')
      )
    );
  }

  var textContent = _react2.default.createElement(
    'div',
    { className: 'kiana-split-text' },
    block.title ? _react2.default.createElement(
      'h3',
      { className: 'kiana-fallback-title' },
      block.title
    ) : null,
    renderRichText(block),
    renderButtons(block, key + '-buttons'),
    renderSpantext(block, key + '-spantext')
  );

  var imageContent = imageSrc ? _react2.default.createElement(
    'div',
    { className: 'kiana-split-image-column' },
    _react2.default.createElement(
      'div',
      { className: 'kiana-split-image-wrap' },
      _react2.default.createElement('img', {
        src: imageSrc,
        alt: block.title || block.name || '',
        className: 'kiana-split-image'
      })
    )
  ) : null;

  return _react2.default.createElement(
    _storyblokReact2.default,
    { key: key, content: block },
    _react2.default.createElement(
      'section',
      { className: 'kiana-section kiana-split-block' },
      imageLeft ? imageContent : textContent,
      imageLeft ? textContent : imageContent
    )
  );
};

var renderContentBlock = function renderContentBlock(block, key) {
  var name = getBlockName(block);

  if (name === 'paragraph with image copy copy') {
    return renderParagraphWithImageCopy(block, key, {
      imageLeft: false,
      magazine: true,
      largeImage: true
    });
  }

  if (name === 'paragraph with image copy' || name.includes('paragraph with image')) {
    return renderParagraphWithImageCopy(block, key, { imageLeft: false });
  }

  if (name === 'rich text' || name === 'lead paragraph') {
    return _react2.default.createElement(
      _storyblokReact2.default,
      { key: key, content: block },
      _react2.default.createElement(
        'section',
        { className: 'kiana-section' },
        renderRichText(block)
      )
    );
  }

  if (name === 'video' || name === 'external video') {
    return _react2.default.createElement(
      _storyblokReact2.default,
      { key: key, content: block },
      _react2.default.createElement(
        'section',
        { className: 'kiana-section' },
        renderVideo(block, key + '-video')
      )
    );
  }

  if (name === 'image') {
    return _react2.default.createElement(
      _storyblokReact2.default,
      { key: key, content: block },
      _react2.default.createElement(
        'section',
        { className: 'kiana-section' },
        renderImage(block, key + '-image')
      )
    );
  }

  if (name === 'member') {
    return renderMember(block, key);
  }

  if (name === 'members hub copy' || name.includes('members hub')) {
    return renderMembersHub(block, key);
  }

  if (name === 'button') {
    return _react2.default.createElement(
      _storyblokReact2.default,
      { key: key, content: block },
      _react2.default.createElement(
        'section',
        { className: 'kiana-section' },
        renderButtons(block, key + '-buttons')
      )
    );
  }

  return _react2.default.createElement(
    _storyblokReact2.default,
    { key: key, content: block },
    _react2.default.createElement(
      'section',
      { className: 'kiana-section' },
      block.title ? _react2.default.createElement(
        'h3',
        { className: 'kiana-fallback-title' },
        block.title
      ) : null,
      renderRichText(block),
      renderImage(block, key + '-image'),
      renderVideo(block, key + '-video'),
      renderButtons(block, key + '-buttons')
    )
  );
};

var isRenderableBlock = function isRenderableBlock(value) {
  return !!(value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && (value.component || value._uid || value.text || value.markdown || value.title));
};

var collectBlocksFromValue = function collectBlocksFromValue(value) {
  var blocks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!value) return blocks;

  if (Array.isArray(value)) {
    value.forEach(function (item) {
      return collectBlocksFromValue(item, blocks);
    });
    return blocks;
  }

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    if (isRenderableBlock(value)) {
      blocks.push(value);
    }

    Object.keys(value).forEach(function (key) {
      collectBlocksFromValue(value[key], blocks);
    });
  }

  return blocks;
};

var uniqueBlocks = function uniqueBlocks(blocks) {
  var seen = new Set();

  return blocks.filter(function (block) {
    var key = block._uid || JSON.stringify(block);

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

var renderPageSubtitle = function renderPageSubtitle(block, key) {
  var sectionTitle = block.text || block.title || block.subtitle;

  if (!isNonEmptyString(sectionTitle)) return null;

  return _react2.default.createElement(
    _storyblokReact2.default,
    { key: key, content: block },
    _react2.default.createElement(
      'section',
      { className: 'kiana-section-group' },
      _react2.default.createElement(
        'h2',
        { className: 'kiana-section-title' },
        sectionTitle
      )
    )
  );
};

var KianaMissionPage = function KianaMissionPage(_ref2) {
  var story = _ref2.story;

  var content = story && story.content || {};
  var topBlocks = Array.isArray(content.top) ? content.top : [];
  var topUidSet = new Set(topBlocks.map(function (block) {
    return block && block._uid;
  }).filter(Boolean));

  var explicitHeroBlock = topBlocks.find(function (block) {
    var name = getBlockName(block);
    return name === 'hero' || name.includes('banner');
  });

  var fallbackHeroBlock = !explicitHeroBlock && topBlocks.length && getImageSrc(topBlocks[0]) ? topBlocks[0] : null;

  var heroBlock = explicitHeroBlock || fallbackHeroBlock || null;

  var bodyBlocks = topBlocks.filter(function (block) {
    return block !== heroBlock;
  });

  var title = heroBlock && (heroBlock.title || heroBlock.subtitle) || story.name || 'Poverty Stoplight';

  var extraBlocks = Array.isArray(content.extra_blocks) ? content.extra_blocks : [];

  var nestedTopBlocks = uniqueBlocks(topBlocks.flatMap(function (block) {
    if (!block || (typeof block === 'undefined' ? 'undefined' : _typeof(block)) !== 'object') return [];

    return Object.keys(block).flatMap(function (key) {
      return collectBlocksFromValue(block[key], []);
    });
  })).filter(function (block) {
    return !(block && block._uid && topUidSet.has(block._uid));
  });

  var additionalFieldBlocks = uniqueBlocks([].concat(_toConsumableArray(nestedTopBlocks), _toConsumableArray(Object.keys(content).filter(function (key) {
    return key !== 'top' && key !== '_uid' && key !== 'component' && key !== 'extra_blocks';
  }).flatMap(function (key) {
    return collectBlocksFromValue(content[key], []);
  })))).filter(function (block) {
    return !(block && block._uid && topUidSet.has(block._uid));
  });

  return _react2.default.createElement(
    'div',
    { className: 'kiana-page' },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        title
      )
    ),
    heroBlock ? _react2.default.createElement(
      _storyblokReact2.default,
      { content: heroBlock },
      _react2.default.createElement(
        'section',
        {
          className: 'hero hero--small kiana-text-hero'
        },
        _react2.default.createElement('div', { className: 'hero__overlay' }),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'h1',
            { className: 'hero__title hero--small__title' },
            title
          )
        )
      )
    ) : null,
    _react2.default.createElement(
      'main',
      { className: 'wrapper kiana-layout' },
      bodyBlocks.map(function (block, index) {
        if (getBlockName(block) === 'page subtitle') {
          return renderPageSubtitle(block, 'subtitle-' + (block._uid || index));
        }

        return renderContentBlock(block, 'body-' + (block._uid || index));
      }),
      extraBlocks.length ? _react2.default.createElement(
        _react2.default.Fragment,
        null,
        bodyBlocks.length ? _react2.default.createElement('hr', { className: 'kiana-divider', 'aria-hidden': 'true' }) : null,
        _react2.default.createElement(
          'section',
          { className: 'kiana-section-group' },
          extraBlocks.map(function (block, index) {
            return renderContentBlock(block, 'extra-' + (block._uid || index));
          })
        )
      ) : null
    )
  );
};

exports.default = (0, _reactStatic.withRouteData)(KianaMissionPage);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/KianaMissionPage.86ba8eb4.js